<template>
  <div class="grad-stat">
    <div class="row justify-content-xl-center align-items-xl-center g-0">
      <div class="col col-xl-auto">
        <div class="row grad-stat__row-top align-items-center align-items-xl-start">
          <div class="col-3 col-lg-2 col-xl-auto"><contentful-image
            :item="imageContentItem"
            class="responsive-img grad-stat__image"
          /></div>
          <div class="col-9 col-lg-10 col-xl-auto">
            <div
              class="grad-stat__statistic"
              style="color: #FFFFFF"
            >{{ statistic }}</div>
            <div class="grad-stat__label d-none d-xl-block">{{ label }}</div>
          </div>
        </div>
        <div class="row grad-stat__row-bottom d-xl-none">
          <div class="col-3 col-lg-2 col-xl-auto"/>
          <div class="col-9 col-xl-auto">
            <div class="grad-stat__label">{{ label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradStat',
  props: {
    statistic: { type: String, default: '', required: true },
    label: { type: String, default: '', required: true },
    imageContentItem: { type: Object, default: null, required: true }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/bootstrap-grid";

.grad-stat {
  margin-bottom: 1rem;
  width: 100%;

  @media screen and (min-width: $screen-sm-min) {
    margin-bottom: 2rem;
  }

  @media screen and (min-width: $screen-md-min) {
    margin-bottom: 0;
  }

  @media screen and (min-width: $screen-xl-min) {
    height: 100px;
    background-image: url('../../assets/grad-stat-border-bg.png');
    background-position: 0 0;
    background-repeat: no-repeat;
  }

  &__row {
    &-top {
      border-left: 1px solid #fff;
      padding: 0 0 0.6rem 0.4rem;

      @media screen and (min-width: $screen-xl-min) {
        border: none;
      }
    }

    &-bottom {
      border-left: 1px solid #6789a8;
      padding: 0 0 0.6rem 0.4rem;

      @media screen and (min-width: $screen-xl-min) {
        border: none;
      }
    }
  }

  &__image {
    height: 54px;
    width: auto !important;
    display: block;
  }

  &__blank {
    position: relative;
    left: -3000px;
  }

  &__statistic {
    color: #b4c2d0;
    font-family: $font-barlow-condensed;
    font-size: 3rem;
    font-weight: bold;
    line-height: 3rem;
    text-transform: uppercase;

    @media screen and (min-width: $screen-sm-min) {
      font-size: 4.6rem;
      line-height: 4.6rem;
    }

    @media screen and (min-width: $screen-md-min) {
      font-size: 3.4rem;
      line-height: 3.4rem;
    }

    @media screen and (min-width: $screen-xl-min) {
      height: 68px;
    }
  }

  &__label {
    color: #fff;
    font-size: 1.4rem;
    line-height: 1.4rem;
    font-family: $font-circular-std;

    @media screen and (min-width: $screen-xl-min) {
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/ContentItems/GradStat.vue